import { fetch } from "../lib/network";
import AppSettings from "../config";
import camelcaseKeys from "camelcase-keys";

export const getAllCrmTopics = (networkHeaders: any) => () =>
  fetch(`${AppSettings.CRM_REQUESTS_API_URL}/all_topic_info`, {
    method: "GET",
    headers: networkHeaders,
  })
    .then((res) => res.json())
    .then((res) => camelcaseKeys(res, { deep: true }));
